import TextInput from "Components/TextInput/TextInput";
import React, { useState } from "react";
import { AnimatePresence, motion } from "framer-motion";
import { Button } from "Components/ui/button";
import UseInnerWidth from "hooks/UseInnerWidth";
import { useUser } from "@clerk/clerk-react";
import { toast } from "sonner";

function Security({ data, setData }) {
  const width = UseInnerWidth();

  const { user } = useUser();

  const handleChangePassword = () => {
    user
      ?.updatePassword({
        currentPassword: data.pass,
        newPassword: data.new_pass,
        signOutOfOtherSessions: true,
      })
      .then(() => {
        setData({ pass: "", new_pass: "", confirm_new_pass: "" });
        toast.success("Password changed successfully", {
          autoClose: 2000,
          className: "bg-green-opacity text-green",
        });
      })
      .catch((error) => {
        toast.error(error.message, {
          autoClose: 2000,
          className: "bg-red-opacity text-red",
        });
      });
  };

  return (
    <AnimatePresence initial={true} mode="wait">
      <motion.form
        exit={{
          opacity: 0,
          x: -100,
        }}
        initial={{
          opacity: 0,
          x: -100,
        }}
        animate={{
          opacity: 1,
          x: 0,
        }}
        className="bg-background-card rounded-lg p-8 grid grid-cols-1 gap-6"
      >
        <TextInput
          label="Current Password"
          required={true}
          placeholder="Password"
          type="password"
          value={data.pass}
          onChange={(e) => setData({ ...data, pass: e.target.value })}
        />
        <TextInput
          label="New Password"
          required={true}
          placeholder="New Password"
          type="password"
          value={data.new_pass}
          onChange={(e) => setData({ ...data, new_pass: e.target.value })}
        />
        <TextInput
          label="Confirm New Password"
          required={true}
          placeholder="Confirm Password"
          type="password"
          value={data.confirm_new_pass}
          onChange={(e) =>
            setData({ ...data, confirm_new_pass: e.target.value })
          }
        />

        <Button
          className={`${width >= 768 && "col-span-full ml-[auto]"}   mt-4`}
          type="button"
          onClick={() => {
            handleChangePassword();
          }}
          disabled={
            !data.pass ||
            !data.new_pass ||
            !data.confirm_new_pass ||
            data.new_pass !== data.confirm_new_pass
          }
        >
          Change Password
        </Button>
      </motion.form>
    </AnimatePresence>
  );
}

export default Security;
